<template>
  <div class="update">
    <AppNavbar ::placeholder="true" :zIndex="999" title="WE+会员卡">
    </AppNavbar>
    <div class="container">
      <img
        class="icon"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5eb1ba8131ea55418da118e59c1c68dd.png"
        alt=""
      />
      <div class="title">WE+会员已全面升级！</div>
      <div class="desc"
        >更多权益，更多服务<br />升级app版本即可享新人优惠价</div
      >
      <div class="btn" @click="bindUpdate">去升级</div>
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  components: {
    AppNavbar
  },
  methods: {
    bindUpdate() {
      this.$betterwe.checkAppUpdate()
    }
  }
}
</script>
<style lang="scss" scoped>
.update {
  overflow: hidden;
  background: #f5f5f5;
  min-height: 100vh;

  .container {
    margin-top: 116px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;

    .icon {
      width: 203px;
      height: 168px;
      margin-bottom: 13px;
    }

    .title {
      font-size: 20px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 28px;
      margin-bottom: 6px;
    }

    .desc {
      font-size: 13px;
      font-family: PingFangSC-Regular, PingFang SC;
      color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
      margin-bottom: 20px;
    }

    .btn {
      text-align: center;
      width: 159px;
      height: 48px;
      background: #ffc136;
      border-radius: 26px;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #450a00;
      line-height: 48px;
    }
  }
}
</style>
